const selectToken = state => state.auth.token;
const selectIsAuthenticated = state => state.auth.authenticated;
const selectInternationalOnly = state => state.auth.internationalOnly;

export default { selectToken, selectIsAuthenticated, selectInternationalOnly };